<template>
  <I18nLangBar
    v-model="innerLang"
    :entity-type="entityType"
    :entity-id="entityId"
    :source-lang="sourceLang"
    :locales="locales"
    @change="$emit('change', $event)"
    @translated="$emit('translated', $event)" />
</template>

<script>
import I18nLangBar from './I18nLangBar.vue'

/**
 * Backward-compatible wrapper: old tabbed translate panel replaced by language switcher.
 * Parent pages should listen to @change and reload field content for the selected language.
 */
export default {
  name: 'I18nTranslatePanel',
  components: { I18nLangBar },
  props: {
    entityType: { type: String, required: true },
    entityId: { type: String, default: '' }
  },
  data() {
    return {
      innerLang: 'en',
      sourceLang: 'en',
      locales: ['en', 'zh', 'tw', 'ar', 'es', 'ru', 'nl', 'pl', 'it', 'fr', 'de', 'pt', 'ja', 'ko', 'hi', 'tr', 'id', 'ur', 'vi', 'th']
    }
  },
  watch: {
    entityId: {
      immediate: true,
      handler() {
        this.loadMeta()
      }
    }
  },
  methods: {
    async loadMeta() {
      try {
        const res = await this.$api.post('/service/i18n/meta', {})
        if (this.$apiSuccess(res)) {
          this.sourceLang = res.data.source_locale || 'en'
          this.locales = res.data.content_locales || this.locales
          this.innerLang = this.sourceLang
        }
      } catch (e) {
        // meta optional
      }
    }
  }
}
</script>
